module.exports = __webpack_public_path__ + "assets/img/agovernment.7916e79e.png";